import { useMediaStore } from '@brightmls/nextgen.lae.mediacenter';

/**
 * Gate component for MediaCenter routes.
 * Blocks rendering until the MediaStore is hydrated by MediaJobOrchestrator.
 *
 * Hydration, WebSocket subscription, job routing, and save handler
 * registration are handled by MediaJobOrchestrator (mounted in
 * EditRouteLoader) so they persist across route changes.
 */
export const MediaCenterDataLoader = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isHydrated = useMediaStore((state) => state.isHydrated);

  if (!isHydrated) {
    return <div>Loading media center...</div>;
  }

  return <>{children}</>;
};
